import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { BASE_IMAGE, IMAGE_WIDTH, IMAGE_HEIGHT, IMAGE_EXTENDED, API_URL, PROGRESS_INFO } from './constants';

import { createResizedImageCrossOrigin, createResizedExternalImage, createCanvasOverlay, convertBase64ToImage } from './utils/imageLoader';
import { createColoredImage, removeBackgroundColor } from './utils/imageManipulation';
import { createTextAsImage } from './utils/textUtilities';
import { getColor, getFurImage, downloadImage, downloadGIF } from './utils/imageUtilities';
import { extractFrames, overlayFrames, createAnimatedGif } from './utils/gifUtilities';

import "./goongenerator.css";
import 'react-toastify/dist/ReactToastify.css';

import Header from './appComponents/Header';
import Gallery from './appComponents/Gallery';
import Footer from './appComponents/Footer';

function App() {
  const [error, setError] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  // character values
  const [goonId, setGoonId] = useState("");
  const [metaData, setMetaData] = useState({ id: '', fur: '', bg: '', image: '' });
  // image related values
  const [bgColor, setBgColor] = useState('');
  const [furColor, setFurColor] = useState(''); 
  // foreground and background values
  const [backgroundBase, setBackgroundBase] = useState(null);
  const [displayImage, setDisplayImage] = useState(null);
  const [transparentImage, setTransparentImage] = useState(null);
  const [gifImage, setGifImage] = useState({ foreground: null, background: null });
  const [bkgThumbs, setBkgThumbs] = useState(null);
  const [txtThumbs, setTxtThumbs] = useState(null);
  const [hndThumbs, setHndThumbs] = useState(null);
  const [txtImage, setTxtImage] = useState(null); 
  const [bkgImage, setBkgImage] = useState({ image: null, mix: 0 });
  const [hndImage, setHndImage] = useState({ image: null, fur: null, tee: null, text: null }); 
  const [teeText, setTeeText] = useState("");
  // const [initialLoad, setInitialLoad] = useState(true);


  const handleTeeTextChange = async (event) => {
    // tee textbox onChange will update a local variable teeText while typing
    setTeeText(event.target.value);
  };


  const handleTeeTextSave = async (event) => {
    setHndImage({ image: hndImage.image, fur: null, tee: true, text: await createTextAsImage(teeText, IMAGE_WIDTH, IMAGE_HEIGHT) });
    setTeeText("");

    CallBuildDisplayFuntion();    
  };  


  const bkgClick = async (image) => { 
    if (image.gif === 0 && gifImage.background !== null) {
      setGifImage({ foreground: gifImage.foreground, background: null });
    }

    if (image.fullSize === "") {
      setBackgroundBase(null);
      setGifImage({ foreground: gifImage.foreground, background: null });
      setBkgImage({ image: null, mix: 0 });
      // if a txtImage was set, clear it too as it needs the extended width set and removing the background will remove that setting too.
      setTxtImage(null);

      toast.success("Cleared the background layer");
    } else {
      if ((image.mix === 0 || image.gif === 1) && txtImage) {
        setTxtImage(null);

      }
      setBackgroundBase(null);

      if (image.gif === 0) {
        setBkgImage({ image: await createResizedImageCrossOrigin(image.fullSize, IMAGE_EXTENDED, IMAGE_HEIGHT), mix: image.mix });
        setGifImage({ foreground: gifImage.foreground, background: null });

      } else {
        setBkgImage({ image: null, mix: 0 });
        setGifImage({ foreground: null, background: image.fullSize });

        toast.warning("Can have either Background or Foreground GIF image");
      }
    }
  };


  const txtClick = async (image) => {
    /*
    if (image.gif === 0 && imageState.gif === 1) {
      setImageState({ mix: 0, gif: 0 });
      setBkgImage(null);
    }
    */

    if (image.fullSize === "") {
      // we've selected 'none' so clear all the background settings
      setBackgroundBase(null);
      setTxtImage(null);
      toast.success("Cleared the text layer");

    } else {
      const backgroundExists = bkgImage.image !== null ? true : false;
      // const gifExists = gifImage.foreground !== null || gifImage.background !== null ? true : false;
      const gifExists = gifImage.background !== null ? true : false;

      // console.log(`*** DEBUG: (txtClick) - BKGEXISTS: ${backgroundExists} - MIX: ${bkgImage.mix} - GIFEXISTS - ${gifExists}`); 

      if ((backgroundExists && bkgImage.mix === 0) || gifExists) {

        toast.warning("Sorry friend, can not overlay text on this background");
        // console.log(`*** DEBUG: (txtClick) - IGNORE TEXT IMAGE AS THE BACKGROUND SEETING PRECLUDES TEXT OVERLAYS`);  

      } else {
        // console.log(`*** DEBUG: (txtClick) - USE TEXT IMAGE`);

        setBackgroundBase(await createColoredImage(IMAGE_EXTENDED, IMAGE_HEIGHT, bgColor));
        setTxtImage(await createResizedImageCrossOrigin(image.fullSize, IMAGE_EXTENDED, IMAGE_HEIGHT));    

      }
    }    
  };  


  const hndClick = async (image) => {
    // console.log(`*** DEBUG: (hndClick) - MIX: ${image.mix}, GIF: ${image.gif}`);     

    if (image.gif === 0 && gifImage.foreground) {
      // clear any foreground gif image
      setGifImage({ forground: null, background: gifImage.background });   
    }

    if (image.fullSize === "") {

      // console.log(`### HNDCLICK: CLEARING - ${hndImage.image !== null} - ${hndImage.fur !== null} - ${hndImage.tee !== null} - ${hndImage.text !== null}`);

      // we've selected 'none' so clear all the foreground settings
      setHndImage({ image: null, fur: null, tee: null, text: null });
      toast.success("Cleared the foreground layer");

    } else {
      let furResized = null;
      setTeeText("");

      // resize the hand image to fit the new background image
      let handResized = await createResizedImageCrossOrigin(image.fullSize, IMAGE_WIDTH, IMAGE_HEIGHT);
      if (image.fullSize.includes("tee-shirt.png")) {
        // TEE_SHIRT IMAGE WAS SELECTED 
        
        setHndImage({ image: handResized, fur: null, tee: true, text: null });

      } else {
        // NO TEE_SHIRT IMAGE SELECTED 

        // check if hand image should have a fur color overlay
        if (image.fur > 0) { 
          const furPaths = furColor.split('|');
          let furOverlay = '';
          switch(image.fur) {
            case 1:
              furOverlay = furPaths[0];
              break;
            case 2:
              furOverlay = furPaths[1];
              break;
            default:
              furOverlay = '';
          }        
          furResized = await createResizedImageCrossOrigin(furOverlay, IMAGE_WIDTH, IMAGE_HEIGHT);

        }

        if (image.gif === 0) {
          // console.log(`### HNDCLICK: IMAGE.GIF === 0 - GIF BKG: ${gifImage.background}`);

          setGifImage({ foreground: null, background: gifImage.background });
          setHndImage({ image: handResized, fur: furResized, tee: false, text: null });
      
        } else {
          // console.log(`### HNDCLICK: IMAGE.GIF !== 0`);

          setHndImage({ image: null, fur: null, tee: null, text: null });
          setGifImage({ foreground: image.fullSize, background: null });
          
        }
      }
    }
  }; 

  
  // get the fur hand image value from a lookup using the metaData.fur name
  async function processGif(gifPath, newDisplayImage, layerType) {
    const frames = await extractFrames(gifPath);
    const overlayedFrames = await overlayFrames(frames, newDisplayImage, layerType); 

    // console.log(`*** DEBUG OVERLAYED FRAMES[0]:- Width: ${overlayedFrames[0].newWidth}, Height: ${overlayedFrames[0].newHeight}`);
    const { delay } = frames[0];       
    return (await createAnimatedGif(overlayedFrames, delay, layerType));

  } 


  async function checkResizeOptions() {
    let imageToResize = 0;
    if ((bkgImage.image) || (gifImage.background)) {
      imageToResize = 1;

    }
    return imageToResize;
  } 


  const buildDisplayImage = async () => {
    let fullImage = null;
    let resizedAvatar = null;

    // console.log(`### BUILD DISPLAY IMAGE LAYERS`);

    fullImage = await createResizedImageCrossOrigin(window.location.origin + BASE_IMAGE, IMAGE_WIDTH, IMAGE_HEIGHT);

    // console.log(`### BASE_IMAGE: ${BASE_IMAGE}`);

    //=======================
    // RESIZE AVATAR
    //=======================

    const imageToResize = await checkResizeOptions();
    try {
      if (imageToResize === 0) {
        // resize the goon image to fit the new background image
        resizedAvatar = await createResizedImageCrossOrigin(metaData.image, IMAGE_WIDTH, IMAGE_HEIGHT);        
      } else {
        // resize the transparent goon image to fit the new background image
        resizedAvatar = await createResizedImageCrossOrigin(transparentImage, IMAGE_WIDTH, IMAGE_HEIGHT);         
      }
    } catch(resizeErr) {
      console.log("Resizing Error in Build Display Image: " + resizeErr);
    }        

    //=======================
    // BUILD LAYERS
    //=======================

    // BACKGROUND STATIC IMAGE
    if (bkgImage.image !== null) {
      fullImage = await createCanvasOverlay(bkgImage.image, fullImage);
    
    }

    // AVATAR
    fullImage = await createCanvasOverlay(fullImage, resizedAvatar);

    // TEXT STATIC IMAGE
    if (txtImage !== null) {
      fullImage = backgroundBase ? await createCanvasOverlay(backgroundBase, fullImage) : fullImage; 
      fullImage = backgroundBase || bkgImage.mix === 1 ? await createCanvasOverlay(fullImage, txtImage) : fullImage;

    }

    if (hndImage.image !== null) {
      // fur set
      let furryHand = hndImage.fur !== null ? await createCanvasOverlay(hndImage.image, hndImage.fur) : null;
      let teeShirt = (hndImage.tee === true && hndImage.text !== null) ? await createCanvasOverlay(hndImage.image, hndImage.text) : null;
      //let teeShirt = (hndImage.tee === true && hndImage.text !== null) ? await overlayShirtText(hndImage.image, hndImage.text, IMAGE_WIDTH, IMAGE_WIDTH, IMAGE_HEIGHT) : null;

      if (furryHand) {
        fullImage = await createCanvasOverlay(fullImage, furryHand);
      } else if (teeShirt) {
        fullImage = await createCanvasOverlay(fullImage, teeShirt);
      } else {
        fullImage = await createCanvasOverlay(fullImage, hndImage.image);
      } 
    }

    //=======================
    // GIFS
    //=======================
    // check if gif settings are 'undefined' and set to null if so
    gifImage.foreground = gifImage.foreground === undefined ? null : gifImage.foreground;
    gifImage.background = gifImage.background === undefined ? null : gifImage.background;

    if (gifImage.foreground !== null || gifImage.background !== null) {
      setIsBusy(true); 
      toast.info("A GIF is being generated...");

      if (gifImage.foreground !== null && (!txtImage && !bkgImage.image)) {
        const newDisplayImage = await convertBase64ToImage(fullImage);
        fullImage = await processGif(gifImage.foreground, newDisplayImage, 1);

      } else if (gifImage.foreground !== null && (txtImage || bkgImage.image)) {
        const newDisplayImage = await convertBase64ToImage(fullImage);
        fullImage = await processGif(gifImage.foreground, newDisplayImage, 2);

      } else if (gifImage.background !== null) {
        const newDisplayImage = await convertBase64ToImage(fullImage);
        fullImage = await processGif(gifImage.background, newDisplayImage, 0);

      }
      setIsBusy(false);        
    }    

    setDisplayImage(fullImage);

  }


  // reset the page
  const Clear = async () => {
    setMetaData({ id: '', fur: '', bg: '', image: '' });
    setGoonId("");
    ResetLoadedValues();
    ResetAdditions();
  }; 


  // reset values loaded when # is selected
  const ResetLoadedValues = async () => {
    setBgColor('');
    setFurColor('');  
    setBkgThumbs(null);
    setTxtThumbs(null); 
    setHndThumbs(null);     
  };  


  // reset backgrounds and foregrounds
  const ResetAdditions = async () => {
    setBackgroundBase(null);
    setDisplayImage(null);
    setTransparentImage(null); 
    setTxtImage(null); 
    setBkgImage({ image: null, mix: 0 });     
    setHndImage({ image: null, fur: null, tee: null, text: null }); 
    setGifImage({ foreground: null, background: null });
  };

  // build the image that will be displayed and downloadable
  async function CallBuildDisplayFuntion() {
    // await buildDisplayImage();
    await buildDisplayImage();

  }  

  useEffect(() => {

    /*
    console.log(`### DEBUG: (USEEFFECT) TRIGGERED BY CHANGE TO ONE OF [bkgImage, txtImage, hndImage, gifImage]`);
    console.log(`### BKGIMAGE: IMAGE: ${bkgImage.image !== null} - MIX: ${bkgImage.mix}`);
    console.log(`### TXTIMAGE: IMAGE: ${txtImage !== null}`);
    console.log(`### HNDIMAGE: IMAGE: ${hndImage.image !== null} - FUR: ${hndImage.fur !== null} - TEE: ${hndImage.tee} - TEXT: ${hndImage.text}`);
    console.log(`### GIFIMAGE: FOREGROUND: ${gifImage.foreground !== null} - BACKGROUND: ${gifImage.background !== null}`);
    */

    //if (initialLoad === true) {
    //  console.log(`Initial Page Load...`);
    //  setInitialLoad(false);
    //}
    //else {
      CallBuildDisplayFuntion();  
    //}

  }, [bkgImage, txtImage, hndImage, gifImage]);  


  // try to make the goon image transparent
  async function MakeMetadataImageTransparent() {
    if (metaData.image) {
      try {
        const resizedLocal = await createResizedImageCrossOrigin(metaData.image, IMAGE_WIDTH, IMAGE_HEIGHT);

        const transparentImg = await removeBackgroundColor(resizedLocal, [0, 0, 0, 255], 20);

        setTransparentImage(transparentImg);
      }
      catch(err) {
        console.log("Create Transparent Image Error: " + err);
      }
    }
  }  

  useEffect(() => {
    MakeMetadataImageTransparent();
  }, [bgColor]);  


  // resize the goon image
  async function ResizeMetadataImage() {
    const resizedImage = await createResizedImageCrossOrigin(metaData.image, IMAGE_WIDTH, IMAGE_HEIGHT);
    setDisplayImage(resizedImage);

  } 
  
  // get the RGB color value from a lookup using the metaData.bg color name
  async function GetColorByName() {
    const colorValue = await getColor(metaData.bg);
    setBgColor(colorValue);
  }  

  // get the fur hand image value from a lookup using the metaData.fur name
  async function GetFurByName() {
    const furImageValue = await getFurImage(metaData.fur);
    setFurColor(furImageValue);
  }  

  // get the bg thumbnail images
  async function GetBGThumbs() {
    try {
      const response = await fetch('/json/backgroundsNew.json');
      const backgroundsData = await response.json();
      setBkgThumbs(backgroundsData); 
    } catch (error) {
      console.log("Error retrieving background json data: " + error);
    }
  } 
  
  // get the txt thumbnail images
  async function GetTxtThumbs() {
    try {
      const response = await fetch('/json/textsNew.json');
      const txtData = await response.json();
      setTxtThumbs(txtData); 
    } catch (error) {
      console.log("Error retrieving text json data: " + error);
    }
  }

  // get the txt thumbnail images
  async function GetHndThumbs() {
    try {
      const response = await fetch('/json/handsNew.json');
      const hndData = await response.json();
      setHndThumbs(hndData); 
    } catch (error) {
      console.log("Error retrieving text json data: " + error);
    }
  }  

  // when metadata is updated
  useEffect(() => {
    if (metaData.id) {

      // setInitialLoad(true);

      ResizeMetadataImage();     

      GetColorByName();    

      GetFurByName();

      GetBGThumbs();    
      
      GetTxtThumbs();  
      
      GetHndThumbs();      

    } else {
      setDisplayImage(null);
    }   
  }, [metaData]);  


  const handleClick = async () => {
    let furValue = '';
    let bgValue = '';

    ResetLoadedValues();
    ResetAdditions();

    try {
      setIsBusy(true);
      const response = await fetch(`${API_URL}/${goonId}`);

      if (response.status === 200) {
        const data = await response.json();
  
        if (data != null) {
          data.attributes.map((item, i) => {
            switch(item.trait_type) {
              case 'Fur':
                furValue = item.value;
                break;
              case 'Background':
                bgValue = item.value;
                break;
              default:
                break;
            } 
          });
  
          setError('');
          setMetaData({ id: data.name, fur: furValue, bg: bgValue, image: data.image });
        } 
      } else {
        setMetaData({ id: '', fur: '', bg: '', image: '' });
        setError('A goon matching the entered id could not be found');
      }      
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsBusy(false);
    }
  }; 
  
  const handleMouseEnter = () => {
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    setShowPopup(false);
  };

  return (
    <div className="App">
      <ToastContainer />      
      <Header 
        goonId={goonId} 
        setGoonId={setGoonId} 
        handleClick={handleClick}
        showPopup={showPopup}
        handleMouseEnter={handleMouseEnter}
        handleMouseLeave={handleMouseLeave}
      />

      <div className="main-section">
        <Gallery 
          title="Background"
          shortTitle="BG"
          thumbs={bkgThumbs}
          onImageClick={bkgClick}
        />

        <Gallery 
          title="Text"
          shortTitle="TEXT"
          thumbs={txtThumbs}
          onImageClick={txtClick}
        />        

        <Gallery 
          title="Hand"
          shortTitle="HAND"
          thumbs={hndThumbs}
          onImageClick={hndClick}
        /> 
             

        {isBusy ? (
          <section className="center">
            <div className="spinner"></div>
            {gifImage.foreground || gifImage.background ? (
              <div>{PROGRESS_INFO}</div>
            ) : (
              <div></div>
            )}
          </section>    
        ) : (          
          <section className="center">
              {error ? (
                <div className="error">{error}</div>
              ) : (
                <div className="title">{metaData.id}</div>
              )}

              {displayImage && ( 
                <div> 
                  <p>
                    <img 
                      src={displayImage} 
                      alt={metaData.id}
                    />               
                  </p> 

                  {hndImage.tee && (
                    <div>
                      <span>Slogan: </span>
                      <input type="text" value={teeText} onChange={handleTeeTextChange} maxLength={30} />
                      <button onClick={handleTeeTextSave}>Save</button>
                      <span> (max 30 chars)</span>
                    </div>
                  )}
                </div>
              )}  
          </section>
        )}         
	    </div>

      {gifImage.foreground === null && gifImage.background === null ? (
        <Footer
          displayImage={displayImage}
          clearFunction={Clear} 
          downloadFunction={downloadImage}
          metaData={metaData}
          bkgImage={bkgImage} 
          txtImage={txtImage} 
        />
      ) : (
        <Footer
          displayImage={displayImage}
          clearFunction={Clear} 
          downloadFunction={downloadGIF}
          metaData={metaData}
          bkgImage={bkgImage} 
          txtImage={txtImage} 
        />        
      )} 

    </div>
  );
}

export default App;
